export default __webpack_public_path__ + "static/github-contributions-e2db5418598944393439bcd20b154339.png";